import { SC } from 'helper/ServerCall';

const DEVICE_TOKEN_KEY = 'gtv_2fa_device';

export const adminUserService = {
    login,
    loginNew,
    twoFaSetup,
    twoFaVerify,
    getTwoFactorUsers,
    resetTwoFactor,
    logout,
    dashboard,
    dashboardMenu,
}

function normalizeUsername(username) {
    return (username || '').toString().trim().toLowerCase();
}

function readDeviceStore() {
    try {
        const raw = localStorage.getItem(DEVICE_TOKEN_KEY);
        if (!raw) {
            return { map: {}, legacy_token: '' };
        }
        try {
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                return { map: parsed, legacy_token: '' };
            }
        } catch (e) {}
        return { map: {}, legacy_token: raw };
    } catch (e) {
        return { map: {}, legacy_token: '' };
    }
}

function getStoredDeviceToken(username) {
    const { map, legacy_token } = readDeviceStore();
    const key = normalizeUsername(username);
    if (key && map[key]) {
        return map[key];
    }
    return legacy_token || '';
}

function persistDeviceToken(response) {
    if (!response || !response.device_token) {
        return response;
    }
    const username = response.user && response.user.username;
    if (!username) {
        return response;
    }
    try {
        const { map } = readDeviceStore();
        map[normalizeUsername(username)] = response.device_token;
        localStorage.setItem(DEVICE_TOKEN_KEY, JSON.stringify(map));
    } catch (e) {}
    return response;
}

function login(username, password) {
    return SC.postCallLoginAdmin('auth/login', { username, password });
}

function loginNew(username, password) {
    const payload = { username, password };
    const device_token = getStoredDeviceToken(username);
    if (device_token) {
        payload.device_token = device_token;
    }
    return SC.postCallLoginAdmin('auth/login-2fa', payload).then(persistDeviceToken);
}

function twoFaSetup(challengeToken, totpCode = null, rememberDevice = false) {
    const data = totpCode ? { totp_code: totpCode, remember_device: !!rememberDevice } : {};
    return SC.postCallLoginAdmin('auth/2fa/setup', data, { 'X-Challenge-Token': challengeToken }).then(persistDeviceToken);
}

function twoFaVerify(challengeToken, totpCode, rememberDevice = false) {
    return SC.postCallLoginAdmin(
        'auth/2fa/verify',
        { totp_code: totpCode, remember_device: !!rememberDevice },
        { 'X-Challenge-Token': challengeToken }
    ).then(persistDeviceToken);
}

function getTwoFactorUsers(page, filter, sort, pageSize) {
    return SC.getCall('twoFactorUsers', { page, filter, sort, pageSize });
}

function resetTwoFactor(userId) {
    return SC.postCall(`twoFactorReset/${userId}`, {});
}

function logout() {
    return SC.getCall('logout');
}

function dashboard() {
    return SC.getCall('dashboard');
}

function dashboardMenu() {
    return SC.getCall('getMenu');
}
